$(function () {

    $('.js_offer_active').click(function () {
        var tabla=document.getElementById('tablaResponsive');
        $.ajax({
            url:   window.location.origin + '/empresas/ofertas/' + $('.js_offer_active').attr('valorActive')+'/'+1,
            type:  'get',
            dataType : 'html',
            success:  function (data) {
                tabla.innerHTML=data;

            }
        });
    })
        
    $('.js_offer_no_active').click(function () {
        var tabla=document.getElementById('tablaResponsive');
        $.ajax({
            url:   window.location.origin + '/empresas/ofertas/' + $('.js_offer_no_active').attr('valorActive')+'/'+0,
            type:  'get',
            dataType : 'html',
            success:  function (data) {
                tabla.innerHTML=data;

            }
        });
    })

    $('.js_offer_total').click(function () {
        var tabla=document.getElementById('tablaResponsive');
        $.ajax({
            url:   window.location.origin + '/empresas/ofertas/' + $('.js_offer_total').attr('valorActive'),
            type:  'get',
            dataType : 'html',
            success:  function (data) {
                tabla.innerHTML=data;
            },
        });
    })


    $(document).ready(function () {


        var $tableCompanies = $('.js-datatable--companies')
        $tableCompanies.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/empresas/list',
                queries: {
                    partner_university_id: $tableCompanies.data('partner_university_id')
                }
            }
        });
        
        $('.js-datatable--companies-users').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/empresas/usuarios/list'
            }
        });

        var $tableStudents = $('.js-datatable--students');
        $tableStudents.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/alumnos/list',
                queries: {
                  university_id: [$tableStudents.data('university_id')],
                  partner_university_id: $tableStudents.data('partner_university_id')
                }
            }
        });

        var $tableJobOffers = $('.js-datatable--offers');
        $tableJobOffers.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/ofertas/list',
                queries: {
                    company_id: $tableJobOffers.data('company_id')
                }
            }
        });

        var $tableJobOffersPetitions = $('.js-datatable--offers-petitions');
        $tableJobOffersPetitions.beTable({
            dataset: {
              ajaxUrl: window.location.origin + '/ofertas/list?petition=1',
              queries: {
                company_id: $tableJobOffersPetitions.data('company_id')
              }
            }
        });

        $('.js-datatable--admin-users').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/admin/list'
            }
        });

        $('.js-datatable--customizations').beTable({
            dataset: {
              ajaxUrl: window.location.origin + '/customizaciones/list'
            }
        });
        
        $('.js-datatable--master-universities').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/universidades/list'
            }
        });

        var agreementsDatatableSelector = $('.js-datatable--agreements');
        agreementsDatatableSelector.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/gestion-de-convenios/convenios-marco/list',
                queries: {
                    university_id: agreementsDatatableSelector.data('university_id'),
                    company_id: agreementsDatatableSelector.data('company_id')
                }
            }
        });

        var annexesDatatableSelector = $('.js-datatable--annexes');
        annexesDatatableSelector.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/gestion-de-convenios/anexos/list',
                queries: {
                    agreement_id: annexesDatatableSelector.data('agreement_id'),
                    student_id: annexesDatatableSelector.data('student_id'),
                    renews_to: annexesDatatableSelector.data('renews_to'),
                }
            }
        });


        var annexesRenewalsDatatableSelector = $('.js-datatable--annexes_renewals');
        annexesRenewalsDatatableSelector.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/gestion-de-convenios/renovaciones-de-anexos/list',
                queries: {
                    annex_id: annexesRenewalsDatatableSelector.data('annex_id')
                }
            }
        });

        $('.js-datatable--master-departments').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/departments/list'
            }
        });

        $('.js-datatable--master-studies').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/estudios/list'
            }
        });
        
        $('.js-datatable--master-group-studies').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/grupos-estudios/list'
            }
        });
        
        $('.js-datatable--master-subjects').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/asignaturas/list'
            }
        });
        
        $('.js-datatable--master-sectors').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/sectores/list',
            }
        });

        $('.js-datatable--master-categories').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/categorias/list',
            }
        });
        
        $('.js-datatable--master-positions').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/master/posiciones/list'
            }
        });
                
        $('.js-datatable--offer-invitations').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/ofertas/invitaciones/' + $('.js-datatable--offer-invitations').attr('data-offerId')
            }
        });

        $('.js-datatable--student-invitations').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/alumnos/invitations/' + $('.js-datatable--student-invitations').attr('data-studentId')
            },
        });
        
        $('.js-datatable--orders').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/pedidos/list'
            }
        });
        
        $('.js-datatable--products').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/productos/list'
            }
        });
        
        $('.js-datatable--invoices').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/facturas/list'
            }
        });

        $('.js-datatable--external-invoices').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/facturas-externas/list'
            }
        });

        $('.js-datatable--job-offer-packages').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/paquetes-de-ofertas/list'
            }
        });
        
        $('.js-datatable--landings').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/landings/list'
            }
        });

        var $evpsDatatableSelector = $('.js-datatable--evps');
        $evpsDatatableSelector.beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/evps/list',
                queries: {
                  jobOfferId: $evpsDatatableSelector.data('job_offer_id')
                }
            }
        });

        $('.js-datatable--modules').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/modules/list'
            }
        });

        $('.js-datatable--themes').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/themes/list'
            }
        });
        
        $('.js-datatable--pages').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/paginas/list'
            }
        });

        $('.js-datatable--news').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/noticias/list'
            }
        });

        $('.js-datatable--news-group').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/grupo-noticias/list'
            }
        });

        $('.js-datatable--content-packages').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/contenidos/list'
            }
        });

        $('.js-datatable--blog-authors').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/blog/autores/list'
            }
        });

        $('.js-datatable--blog-news').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/blog/noticias/list'
            }
        });

        $('.js-datatable--blog-quotes').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/blog/citas/list'
            }
        });

        $('.js-datatable--blog-banners').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/blog/banners/list'
            }
        });

        $('.js-datatable--blog-author-quotes').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/blog/citas/list?blog_author_id='+$('.js-datatable--blog-author-quotes').attr('data-id')
            }
        });

        $('.js-datatable--blog-author-news').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/blog/noticias/list?blog_author_id='+$('.js-datatable--blog-author-news').attr('data-id')
            }
        });

        var $beUniversityAdminUsersSelector = $('.js-datatable--beuniversity-admin-users');
        $beUniversityAdminUsersSelector.beTable({
            dataset: {
              ajaxUrl: window.location.origin + '/beuniversity/admin-users/list',
              queries: {
                partner_university_id: $beUniversityAdminUsersSelector.data('partner_university_id')
              }
            }
        });

        $('.js-datatable--beuniversity-partner-universities').beTable({
            dataset: {
                ajaxUrl: window.location.origin + '/beuniversity/partner-universities/list'
            }
        });

        $('.js-datatable--simple').dynatable({features: {search: false}}).data('dynatable');

        $('.js-datatable--studentPartners').beTable({
         dataset: {
             ajaxUrl: window.location.origin + '/alumnos/' +  $('.js-datatable--studentPartners').attr('data-studentId') + '/partners'
         },
          features: {
            recordCount: false,
            perPageSelect: false
          }
         });

      $('.js-datatable--fields').beTable({
        dataset: {
          ajaxUrl: window.location.origin + '/dynamic-fields/fields/list'
        }
      });

      $('.js-datatable--fieldGroups').beTable({
        dataset: {
          ajaxUrl: window.location.origin + '/dynamic-fields/field-groups/list'
        }
      });

      $('.js-datatable--fieldGroupPartners').beTable({
        dataset: {
          ajaxUrl: window.location.origin + '/dynamic-fields/field-groups/' +  $('.js-datatable--fieldGroupPartners').attr('data-fieldGroupId') + '/partners'
        },
        features: {
          recordCount: false,
          perPageSelect: false
        }
      });

      $('.js-datatable--fieldFieldGroups').beTable({
        dataset: {
          ajaxUrl: window.location.origin + '/dynamic-fields/fields/' +  $('.js-datatable--fieldFieldGroups').attr('data-fieldId') + '/field-groups'
        },
        features: {
          recordCount: false,
          perPageSelect: false
        }
      });
    });

});
